import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // Set Spanish as the default language
    fallbackLng: 'es',
    defaultNS: 'translation',
    
    // Configure language detection order
    detection: {
      // Order of detection: cookie first, then localStorage, then navigator
      order: ['cookie', 'localStorage', 'navigator', 'htmlTag'],
      
      // Look for language in these places
      lookupCookie: 'i18next',
      lookupLocalStorage: 'i18nextLng',
      
      // Cache the language selection
      caches: ['localStorage', 'cookie'],
      
      // Cookie options
      cookieMinutes: 10080, // 7 days
      cookieDomain: window.location.hostname,
      
      // HTML tag attribute
      htmlTag: document.documentElement,
    },
    
    debug: process.env.NODE_ENV === 'development',
    
    interpolation: {
      escapeValue: false,
    },
    
    backend: {
      loadPath: '/locales/{{lng}}/common.json',
    },
    
    react: {
      useSuspense: true,
    },
    
    // Set initial language to Spanish if no saved language exists
    initImmediate: true,
  });

// Set Spanish as the initial language if no language is set
const savedLanguage = localStorage.getItem('i18nextLng') || 
                      document.cookie.match(/i18next=([^;]+)/)?.[1];

if (!savedLanguage) {
  i18n.changeLanguage('es');
}

export default i18n;